import PageTitle from 'components/elems/typography/pageTitle';

const Cookies = () => (
  <div className="px-6">
    <PageTitle force className="mb-16 font-bold">
      Cookie policy
    </PageTitle>
    <h3 className="text-center text-xl my-6">
      1. About cookies
    </h3>
    <p>
      A cookie is a file containing an identifier (a string of letters and numbers)
      that is sent by a web server to a web browser, and stored by the browser.
      The identifier is then sent back to the server each time the browser requests a page from the server.
    </p>
    <p>
      Cookies can be used by web servers to identity and track users as they navigate
      different pages on a website and to identify users returning to a website.
    </p>
    <p>
      Cookies may be either “persistent” cookies or “session” cookies. A persistent
      cookie consists of a text file sent by a web server to a web browser, which will be stored by the browser and
      will remain valid until its set expiry date (unless deleted by the user before the expiry date). A session cookie,
      on the other hand, will expire at the end of the user session, when the web browser is closed.
    </p>

    <h3 className="text-center text-xl my-6">
      2. Cookies used on the site
    </h3>
    <p>
      We use performance/analytics cookies to analyze how our websites and apps are accessed,
      used, or performing in order to provide you with a better user experience and to maintain,
      operate and continually improve our website.
    </p>
    <p className="mb-2">
      Some of our cookies record information about choices you&apos;ve made on previous visits to
      our website, and allow us to tailor our website to you. These cookies mean that when you continue
      to use or come back to our website, we can provide you with our services as you have asked for them to be provided.
    </p>
    <p className="mb-2">
      We use Google Analytics, which is a web analytics tool that help us understand how users engage with our website.
      Like many services, Google Analytics use first-party cookies to track user interactions. These cookies allow us
      (via such third parties) to collect information about how users use our website. This information is used to compile reports
      (which disclose website trends but without identifying individual visitors) and to help us improve our website.
    </p>
    <p>
      Performance and analytics cookies allow us to continually review and improve the layout and functionality of our website
      to give you the best experience, including:
    </p>
    <p className="pl-4">
      - better understand the way visitors use and interact with our website so that we can improve how we present our content;
    </p>
    <p className="pl-4">
      - use the data collected by such cookies to experiment with different design ideas for particular pages, such as our homepage;
    </p>
    <p className="pl-4">
      - collect information about visitors to our website, such as what devices and browsers our visitors use;
    </p>
    <p className="pl-4">
      - determine the number of unique users of our website;
    </p>
    <p className="pl-4">
      - improve our website by measuring any errors that occur;
    </p>
    <p className="pl-4">
      - conduct research and diagnostics to improve product offerings.
    </p>

    <h3 className="text-center text-xl my-6">
      3. Advertising and Targeting Cookies
    </h3>
    <p>
      We allow third party companies, including advertising companies, to place cookies on our website.
    </p>
    <p>
      These cookies enable such companies to track your activity across various sites where they display
      adverts and record your activities so they can show adverts and promotions that they consider
      relevant to you as you browse the internet.
    </p>
    <p>
      Cookies also allow us and third parties to know whether you have seen an advert (or a type of advert),
      and how long it has been since you have last seen it. This information is used for frequency capping purposes,
      to help tailor the adverts you see, and to measure the effectiveness of adverts.
    </p>
    <p>
      We can use information from one device to help personalize your experience on another device.
    </p>

    <h3 className="text-center text-xl my-6">
      4. Blocking, Deleting cookies
    </h3>
    <p>
      Most browsers allow you to refuse to accept cookies or delete cookies already stored on your computer
    </p>
    <p>
      Should you wish to learn more about cookies, you can do so by visiting www.allaboutcookies.org.
    </p>
  </div>
);

export default Cookies;
